<template>
    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label">Inspection</label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="control has-icons-left">
                    <input class="input" v-model="inspection_japan" type="text" placeholder="Inspection Japan" :class="{ 'is-danger': errors.inspection_japan }">
                    <span class="icon is-left">
                       <i class="fas fa-search"></i>
                    </span>
                    <p v-if="errors.inspection_japan" class="help is-danger">{{ errors.inspection_japan[0] }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {

            }
        },
        computed: {
            inspection_japan: {
                get() {
                    return this.$store.getters.getNewPricePlan.inspection_japan
                },
                set(value) {
                    this.$store.dispatch('setNewPricePlanFieldValue', {field: 'inspection_japan', value: value})
                }
            },
            errors() {
                return this.$store.getters.getNewPricePlanErrors
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/PricePlans/NewPlan/Inputs/InspectionJapanInput.vue